import React from 'react';
import { BoxHeaderWrapper, BoxHeaderTitle } from './MigrationMessage.styled';
import Box from '@components/atoms/box/Box';
import { Heading } from '@components/atoms/heading/Heading';
import Svg from '@components/atoms/svg/Svg';
import Button from '@components/atoms/button/Button';

const MigrationMessage = ({ onOpenPopup }) => {
  return (
    <Box
      color="grey"
      radius="medium"
      css={{
        padding: '$24',
        marginBottom: '$24',
        '@bp2': {
          padding: '$32 $48',
          marginBottom: '$24',
        },
        '@bp3': {
          padding: '$32 $54',
          marginBottom: '$32',
        },
      }}
    >
      <BoxHeaderWrapper>
        <BoxHeaderTitle>
          <span>
            <Svg
              icon="warning"
              css={{
                fill: '$red',
                height: '$24',
                width: '$24',
                marginRight: '$12',
              }}
            />
          </span>
          <Heading css={{ fontFamily: '$ArtifaktLegendBold' }} level="h4">
            Account migration
          </Heading>
        </BoxHeaderTitle>
        <Button
          type="normal"
          colorTheme="white"
          actionType="onclick"
          onClick={onOpenPopup}
        >
          Learn More
        </Button>
      </BoxHeaderWrapper>
    </Box>
  );
};

export default MigrationMessage;
